import React, { useState } from 'react'
import Text from '../../Text'
import shopItemStyles from '../styles.module.css'
import { $interactivePrimary, $textPrimary, $textTertiary, $textInteractive } from '../../../styles/colors/semantics'
import { $black, $neutralGray100, $neutralGray30, $neutralGray70 , $green50, $white } from '../../../styles/colors/primitives'
import ProgressiveImage from '../../sections/ProgressiveImage'
import MyLoader from '../../Utils/MyLoader'
import SmartLink from '../../SmartLink'
import { formatPrice, price } from '../../../utils/formats'
import Spacer from '../../Spacer'
import TimeOrStockLimitCountdownBF2025 from '../../Utils/Countdown/ItemCountdownBF2025'
import BlackFridayTag from '../BlackFridayTag'
import styles from './styles.module.css'
import GiftIcon from '../../icons/GiftIcon'

function ShopItemBF2025Gift({ dark, isLoading, name, typeNames, freeBonuses, mainImage, hoverImage, regularPriceObj,
                    discountPriceObj, priceObj, price, discountPrice, outOfStock, outOfStockMessage, isNew,
                    isPreOrder, pricePrefix, timeLimit, stockLimit, stockLimitLeft, externalLink }) {
  // taxIncluded = taxIncluded ? taxIncluded.replaceAll(/ *\([^)]*\) */g, '').trim() : null
  const hasDiscount = !!discountPrice && discountPrice !== price
  const discountPercentage = hasDiscount && !!price && (100 - (discountPriceObj.priceCents / regularPriceObj.priceCents) * 100).toFixed(0)
  const youSave = hasDiscount && !!price && (- (discountPriceObj.priceCents - regularPriceObj.priceCents))

  if (isLoading) {
    return (
      <div className={shopItemStyles.loaderWrapper} style={{ background: dark ? $neutralGray100 : $white }}>
        <MyLoader isLoading={isLoading}/>
      </div>
    )
  }

  return (
    <SmartLink
      href={externalLink || '#'}
      className={[shopItemStyles.wrapper, !hoverImage ? null : shopItemStyles.wrapperHoverable].filter(Boolean).join(' ')}
      style={{ background: dark ? $black : 'transparent', color: dark ? $textPrimary.dark : 'inherit' }}
    >
        <div
          className={[shopItemStyles.imageWrapper, (outOfStock && !isNew) ? shopItemStyles.imageWrapperDisabled : null].filter(Boolean).join(' ')}
          style={{ background: dark ? $neutralGray100 : '#F4F4F4' }}
        >
          <div className={[styles.mainImage, styles.mainImageFullWidth].join(' ') + ' main-image'}><ProgressiveImage {...mainImage}/></div>
          <div className={shopItemStyles.hoverImage + ' hover-image'}><ProgressiveImage {...hoverImage}/></div>
          <BlackFridayTag show={true}/>
        </div>
        { youSave && youSave > 0 && <div className={styles.youSaveWrapper} style={{ background: $interactivePrimary.light }}>
          <Text type={'heading-4'} color={$white}>YOU SAVE {formatPrice({ priceCents: youSave, currency: priceObj.currency })}</Text>
        </div>}
        { (timeLimit || stockLimit > 0) && <TimeOrStockLimitCountdownBF2025 launchDate={new Date(timeLimit)} stockLimit={stockLimit} stockLimitLeft={stockLimitLeft} theme="dark"/> }
        <div className={shopItemStyles.itemInfoWrapper}>
          <div className={shopItemStyles.priceAndTaxWrapper}>
            <div className={shopItemStyles.priceWrapper}>
              {pricePrefix && <Text type={'heading-7'}>{pricePrefix}</Text>}
              <div
                className={[shopItemStyles.discountPrice, hasDiscount ? shopItemStyles.shown : shopItemStyles.hidden].join(' ')}
                style={{ background: dark ? $black : 'transparent', color: $textInteractive.light }}
              >
                <Text type="heading-5">{discountPrice}</Text>
              </div>
              <div className={shopItemStyles.priceAndDiscountPercentage} style={{ background: dark ? $black : 'transparent' }}>
                <div
                  className={[shopItemStyles.price, hasDiscount ? shopItemStyles.priceHasDiscount : null].filter(Boolean).join(' ')}
                  style={hasDiscount ? { color: $textTertiary.light } : undefined}
                >
                  <Text type={hasDiscount ? 'small' : 'heading-7'}>{price}</Text>
                </div>
                {
                  discountPercentage > 0 && <div className={shopItemStyles.discountPercentage} style={{ color: dark ? $textInteractive.light : 'transparent' }}>
                    <Text type="tiny">-{discountPercentage}%</Text>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className={shopItemStyles.title}>
            <Text type="medium">{name}</Text>
            <Spacer size={4}/>
            { typeNames && typeNames.map(n => <Text type="small" key={n} color={dark ? $textTertiary.dark : $textTertiary.light}>{n}</Text>) }
            { renderBonuses(freeBonuses) }
          </div>
          <div
            className={[shopItemStyles.outOfStockTag, outOfStock ? shopItemStyles.shown : shopItemStyles.hidden].join(' ')}
            style={{ background: $neutralGray30, color: $neutralGray70 }}
          >
            <Text type="tiny">{outOfStockMessage}</Text>
          </div>
        </div>
    </SmartLink>
  )
}

const renderBonuses = (freeBonuses) => {
  if(!freeBonuses || Object.keys(freeBonuses).length === 0) return null
  return (
    <div className={styles.bonuses}>
      { freeBonuses && Object.keys(freeBonuses).map(k => (
        <>
        {
          !!freeBonuses[k] ? <Text type="small"
                highlight={'FREE'}
                highlightSx={`color: ${$green50}; font-weight: 500;`}
                color={$textTertiary.dark}
          >+ GIFT: { k } for <span className={shopItemStyles.lineThroughSpan}>{formatPrice(freeBonuses[k])}</span> FREE</Text>
            : <Text type="small"
                    highlight={'FREE'}
                    highlightSx={`color: ${$green50}; font-weight: 500;`}
                    color={$textTertiary.dark}
            >{k}</Text>
        }
        </>
      ))
      }
    </div>
  )
}

const renderBonusBIG = (bonus, price) => {
  if(!bonus) return null
  return (
    <div className={styles.bigBonusWrapper}>
      { bonus && <div className="flex items-center justify-center gap-1">
          <div className="hidden lg:block">
            <GiftIcon/>
          </div>
          <Text type="heading-9"
                highlight={'FREE'}
                highlightSx={`color: ${$green50}; font-weight: 500;`}
                color={$textPrimary.dark}
          >+ { bonus } for <span className={shopItemStyles.lineThroughSpan}>{formatPrice(price)}</span> FREE</Text>
        </div>
      }
    </div>
  )
}

export default ShopItemBF2025Gift
